"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminView = void 0;
const Log_1 = __importDefault(require("@common/Log"));
const Factory_1 = require("../Factory");
const ClassMode_1 = require("../util/ClassMode");
const UI_1 = require("../util/UI");
const ViewAs_1 = require("../util/ViewAs");
const AdminConfigTab_1 = require("./AdminConfigTab");
const AdminDashboardTab_1 = require("./AdminDashboardTab");
const AdminDeliverablesTab_1 = require("./AdminDeliverablesTab");
const AdminGradesTab_1 = require("./AdminGradesTab");
const AdminResultsTab_1 = require("./AdminResultsTab");
const AdminStudentsTab_1 = require("./AdminStudentsTab");
const AdminTeamsTab_1 = require("./AdminTeamsTab");
class AdminView {
    constructor(remoteUrl, tabs) {
        this.remote = null;
        this.tabs = null;
        this.isStaff = false;
        this.isAdmin = false;
        this.currentPage = null;
        Log_1.default.info("AdminView::<init>");
        this.remote = remoteUrl;
        this.tabs = tabs;
        this.deliverablesTab = new AdminDeliverablesTab_1.AdminDeliverablesTab(remoteUrl, this.isAdmin);
        this.studentsTab = new AdminStudentsTab_1.AdminStudentsTab(remoteUrl);
        this.teamsTab = new AdminTeamsTab_1.AdminTeamsTab(remoteUrl);
        this.gradesTab = new AdminGradesTab_1.AdminGradesTab(remoteUrl);
        this.resultsTab = new AdminResultsTab_1.AdminResultsTab(remoteUrl);
        this.dashTab = new AdminDashboardTab_1.AdminDashboardTab(remoteUrl);
        this.configTab = new AdminConfigTab_1.AdminConfigTab(remoteUrl, this.isAdmin);
    }
    renderPage(name, opts) {
        Log_1.default.info("AdminView::renderPage( " + name + ", ... ) - start; options: " + JSON.stringify(opts));
        if (this.tabs !== null) {
            this.setTabVisibility("AdminStudentTab", this.tabs.students);
            this.setTabVisibility("AdminTeamTab", this.tabs.teams);
            this.setTabVisibility("AdminResultTab", this.tabs.results);
            this.setTabVisibility("AdminGradeTab", this.tabs.grades);
            this.setTabVisibility("AdminDashboardTab", this.tabs.dashboard);
            this.setTabVisibility("AdminConfigTab", this.tabs.config);
        }
        if (typeof opts.isAdmin !== "undefined") {
            this.isAdmin = opts.isAdmin;
        }
        if (typeof opts.isStaff !== "undefined") {
            this.isStaff = opts.isStaff;
        }
        this.deliverablesTab.setAdmin(this.isAdmin);
        this.configTab.setAdmin(this.isAdmin);
        if (this.isAdmin === false) {
            Log_1.default.info("AdminView::renderPage(..) - !admin; hiding config tab");
            this.setTabVisibility("AdminConfigTab", false);
        }
        this.renderClassModeButton();
        const classMode = ClassMode_1.ClassMode.isOn() === true;
        if (classMode === true) {
            this.setTabVisibility("AdminStudentTab", false);
            this.setTabVisibility("AdminTeamTab", false);
        }
        else if (this.tabs === null) {
            this.setTabVisibility("AdminStudentTab", true);
            this.setTabVisibility("AdminTeamTab", true);
        }
        if (classMode === true && (name === "AdminStudents" || name === "AdminTeams")) {
            this.showFirstVisibleTab();
            return;
        }
        if (name !== "AdminRoot") {
            this.currentPage = name;
        }
        const functionName = "handle" + name;
        if (typeof this[functionName] === "function") {
            Log_1.default.info("AdminView::renderPage(..) - calling: " + functionName);
            this[functionName](opts);
        }
        else {
            Log_1.default.warn("AdminView::renderPage(..) - unknown page: " + name + " (function: " + functionName + " not defined on view).");
        }
    }
    renderClassModeButton() {
        const button = document.getElementById("adminClassModeButton");
        if (button === null) {
            return;
        }
        button.style.display = this.isAdmin === true || ClassMode_1.ClassMode.isOn() === true ? "" : "none";
        const label = document.getElementById("adminClassModeLabel");
        if (label !== null) {
            label.textContent = ClassMode_1.ClassMode.isOn() === true ? "Leave Class Mode" : "Enter Class Mode";
        }
        button.onclick = () => {
            this.toggleClassMode();
        };
    }
    toggleClassMode() {
        var _a;
        const on = ClassMode_1.ClassMode.isOn() === false;
        ClassMode_1.ClassMode.set(on);
        Log_1.default.info("AdminView::toggleClassMode() - class mode: " + on + "; page: " + this.currentPage);
        this.renderPage((_a = this.currentPage) !== null && _a !== void 0 ? _a : "AdminRoot", {});
    }
    showFirstVisibleTab() {
        const tabbar = document.getElementById("adminTabbar");
        const tabs = Array.from(document.querySelectorAll("#adminTabbar ons-tab"));
        const first = tabs.findIndex((tab) => tab.style.display !== "none");
        if (tabbar !== null && typeof tabbar.setActiveTab === "function" && first >= 0) {
            void tabbar.setActiveTab(first);
        }
        else {
            Log_1.default.warn("AdminView::showFirstVisibleTab() - no tab to move to");
        }
    }
    setTabVisibility(name, visible) {
        const e = document.getElementById(name);
        if (e !== null) {
            if (visible === false) {
                e.style.display = "none";
            }
            else {
                e.style.display = "";
            }
        }
        else {
            Log_1.default.warn("AdminView::setTabVisibility( " + name + ", " + visible + " ) - tab not found");
        }
    }
    static showError(failure) {
        var _a;
        Log_1.default.error("AdminView::showError(..) - start");
        try {
            UI_1.UI.hideModal();
            const f = JSON.parse(failure);
            if (f !== null) {
                failure = f;
            }
        }
        catch (_err) {
        }
        if (typeof failure === "string") {
            Log_1.default.error("AdminView::showError(..) - failure: " + failure);
            UI_1.UI.showAlert(failure);
        }
        else if (typeof ((_a = failure === null || failure === void 0 ? void 0 : failure.failure) === null || _a === void 0 ? void 0 : _a.message) === "string") {
            Log_1.default.error("AdminView::showError(..) - failure message: " + failure.failure.message);
            UI_1.UI.showAlert(failure.failure.message);
        }
        else if (typeof (failure === null || failure === void 0 ? void 0 : failure.message) === "string") {
            Log_1.default.error("AdminView::showError(..) - non-Classy failure: " + failure.message);
            UI_1.UI.showAlert(failure.message);
        }
        else {
            Log_1.default.error("AdminView::showError(..) - Unknown message: " + failure);
            UI_1.UI.showAlert("Action unsuccessful.");
        }
    }
    static getOptions() {
        return {
            headers: ViewAs_1.ViewAs.addHeader({
                "Content-Type": "application/json",
                user: localStorage.user,
                token: localStorage.token,
            }),
        };
    }
    handleAdminRoot(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminView::handleAdminRoot(..) - start");
            return;
        });
    }
    handleAdminDeliverables(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminView::handleAdminDeliverables(..) - start");
            return this.deliverablesTab.init(opts);
        });
    }
    handleAdminConfig(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminView::handleAdminConfig(..) - start");
            return this.configTab.init(opts);
        });
    }
    handleAdminStudents(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminView::handleStudents(..) - start");
            return this.studentsTab.init(opts);
        });
    }
    handleAdminTeams(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminView::handleTeams(..) - start");
            return this.teamsTab.init(opts);
        });
    }
    handleAdminGrades(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminView::handleGrades(..) - start");
            return this.gradesTab.init(opts);
        });
    }
    handleAdminResults(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminView::handleResults(..) - start");
            return this.resultsTab.init(opts);
        });
    }
    handleAdminDashboard(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminView::handleDashboard(..) - start");
            return this.dashTab.init(opts);
        });
    }
    handleAdminEditDeliverable(opts) {
        this.deliverablesTab
            .initEditDeliverablePage(opts)
            .then(function () {
        })
            .catch(function (err) {
        });
    }
    pushPage(pageName, opts) {
        Log_1.default.info("AdminView::pushPage( " + pageName + ", ... ) - start");
        if (typeof opts !== "object") {
            opts = {};
        }
        const prefix = Factory_1.Factory.getInstance().getHTMLPrefix();
        UI_1.UI.pushPage(prefix + "/" + pageName, opts)
            .then(function () {
        })
            .catch(function (err) {
            Log_1.default.error("UI::pushPage(..) - ERROR: " + err.message);
        });
    }
    static getCourse(remote) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const options = AdminView.getOptions();
                const url = remote + "/portal/admin/course";
                const response = yield fetch(url, options);
                const start = Date.now();
                if (response.status === 200 || response.status === 400) {
                    Log_1.default.trace("AdminView::getCourse(..) - 200 received for course options");
                    const json = yield response.json();
                    if (typeof json.success !== "undefined") {
                        Log_1.default.trace("AdminView::getCourse(..)  - worked; took: " + UI_1.UI.took(start));
                        return json.success;
                    }
                    else {
                        Log_1.default.trace("AdminView::getCourse(..)  - ERROR: " + json.failure.message);
                        AdminView.showError(json.failure);
                    }
                }
                else {
                    Log_1.default.trace("AdminView::getCourse(..)  - !200 received: " + response.status);
                    const text = yield response.text();
                    AdminView.showError(text);
                }
            }
            catch (err) {
                AdminView.showError("Getting config failed: " + err.message);
            }
            return null;
        });
    }
}
exports.AdminView = AdminView;
